/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setApMerchantIdAssociation} from '../api'

export const useMutationSetApMerchantIdAssociation = createReactQueryMutationHook('setApMerchantIdAssociation', setApMerchantIdAssociation)
